import { useState } from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import {
  AppBar,
  Tabs,
  Tab,
  Typography,
  Box,
} from "@mui/material";
import CultivateMonitorDash from "../components/datagrid/RegionGrid";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function FullWidthTabs() {
  const theme = useTheme();
  const [site, setSite] = useState(0);

  const handleChange = (event, newValue) => {
    setSite(newValue);
  };

  return (
    <Box sx={{ bgcolor: "background.paper", width: "100%", padding: "10px" }}>
      <AppBar position="static">
        <Tabs
          value={site}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="inherit"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab label="Lab Q4" {...a11yProps(0)} />
          <Tab label="Experimental" {...a11yProps(1)} />
          <Tab label="Client" {...a11yProps(2)} />
        </Tabs>
      </AppBar>
      <TabPanel value={site} index={0} dir={theme.direction}>
        Lab Q4
      </TabPanel>
      <TabPanel value={site} index={1} dir={theme.direction}>
        Experimental
      </TabPanel>
      <TabPanel value={site} index={2} dir={theme.direction}>
        Clients
      </TabPanel>
      <Box sx={{ padding: "10px" }}>
        <CultivateMonitorDash where={site} />
      </Box>
    </Box>
  );
}
